import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockForwardsFilled"
const ClockForwardsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.632 2.131C11.092 1.385 13.744 1.585 16.065 2.692 17.392 3.325 18.555 4.23 19.49 5.332V3.75H21.367V9.553H16.5V7.678H18.869C18.02 6.255 16.769 5.104 15.257 4.383 13.358 3.48 11.19 3.315 9.176 3.926 7.163 4.536 5.45 5.878 4.374 7.686S2.937 11.639 3.361 13.7C3.784 15.76 4.963 17.589 6.665 18.826 8.367 20.062 10.47 20.619 12.561 20.386 14.652 20.152 16.581 19.146 17.968 17.564S20.102 13.94 20.061 11.835L21.936 11.8C21.986 14.369 21.074 16.867 19.378 18.8 17.682 20.734 15.325 21.963 12.769 22.249 10.214 22.534 7.643 21.854 5.563 20.342 3.483 18.831 2.043 16.597 1.524 14.078S1.448 8.938 2.763 6.728 6.17 2.877 8.632 2.13" />
          <path d="M10.688 6.75C11.723 6.75 12.563 7.59 12.563 8.625V11.612L14.337 13.386C15.07 14.12 15.07 15.307 14.337 16.039L10.687 12.388z" />
        </svg>
      }
    </span>
  )
}
export default ClockForwardsFilledIcon
